import { Facebook, Instagram, Twitter } from "react-feather";
import { Link } from "react-router-dom";

const CorporateLandingTemplate = ({ data, isStickyHeader }) => {

    return (<div style={{ fontFamily: "Arial, sans-serif", background: "#f4f7fb", color: "#111" }}>
        <header style={{ background: "rgba(0,27,77,0.96)", color: "#fff", position: isStickyHeader ? "sticky" : "relative", top: 0, zIndex: 999, width: "100%", backdropFilter: "blur(10px)", boxShadow: "0 2px 10px rgba(0,0,0,0.15)" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "20px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                <div style={{ width: '200px', height: 'auto' }}>
                    <img src={data && data?.logoURL ? data?.logoURL : "/images/logo.svg"} alt="logo" style={{ maxHeight: '67px' }} />
                </div>

                <nav style={{ display: "flex", gap: "35px", alignItems: "center" }}>
                    <Link to={"/sign-in"} style={navLink}>Sign In</Link>
                    <Link to={"/track-booking"} style={navLink}>Track</Link>

                    <button style={{ background: "#0d6efd", color: "#fff", border: "none", padding: "12px 22px", cursor: "pointer", fontWeight: "600", fontSize: "15px", }}>{data && data?.phone ? data?.phone : ""}</button>
                </nav>
            </div>
        </header>

        <section style={{ background: `linear-gradient(90deg, #001b4d 35%,rgba(0,27,77,0.6) 55%, transparent 100%), url(${data?.bannerImage ? data.bannerImage : "/images/template1-banner.jfif"})`, backgroundSize: "cover", backgroundPosition: "top center", minHeight: "700px", display: "flex", alignItems: "center", color: "#fff" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", width: "100%", padding: "0 40px" }}>
                <div style={{ maxWidth: "650px" }}>
                    <h1 style={{ fontSize: "78px", lineHeight: "88px", marginBottom: "25px", fontWeight: "700" }}>{data && data?.heroTitle ? data?.heroTitle : ""}</h1>
                    <h3 style={{ fontSize: "30px", marginBottom: "25px", fontWeight: "500" }}>{data && data?.heroSubTitle ? data?.heroSubTitle : ""}</h3>
                    <p style={{ fontSize: "22px", lineHeight: "40px", opacity: 0.95 }}>{data && data?.heroDescription ? data?.heroDescription : ""}</p>
                </div>
            </div>
        </section>

        <section style={{ padding: "100px 0", background: "#fff" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px" }}>
                <h2 style={{ textAlign: "center", fontSize: "50px", marginBottom: "70px" }}>{data && data?.serviceTitle ? data?.serviceTitle : ""}</h2>
                <div style={{ display: "flex", gap: "20px" }}>
                    {data?.services.map((item, index) => (<div key={index} style={{ background: "#fff", padding: "50px 35px", textAlign: "center", border: "1px solid #e8edf5", boxShadow: "0 4px 15px rgba(0,0,0,0.06)" }}>
                        <div style={{ fontSize: "70px", marginBottom: "25px" }}><img src={item?.icon} alt="icon" style={{ maxHeight: '64px', maxWidth: '64px' }} /></div>
                        <h3 style={{ fontSize: "28px", marginBottom: "18px" }}>{item.title}</h3>
                        <p style={{ color: "#666", lineHeight: "32px", fontSize: "18px" }}>{item.description}</p>
                    </div>))}
                </div>
            </div>
        </section>

        <section style={{ padding: "100px 0", background: "#f7f9fc" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "70px", alignItems: "center" }}>
                <div>
                    <img src={data && data?.aboutImage ? data?.aboutImage : "/images/template1-image.jfif"} alt="warehouse" style={{ width: "100%", objectFit: "cover" }} />
                </div>

                <div>
                    <h2 style={{ fontSize: "56px", marginBottom: "30px", color: "#001b4d", lineHeight: "68px" }}>{data && data?.aboutTitle ? data?.aboutTitle : ""}</h2>
                    <p style={{ fontSize: "21px", lineHeight: "40px", color: "#555" }}>{data && data?.aboutDescription ? data?.aboutDescription : ""}</p>
                </div>
            </div>
        </section>

        <footer style={{ background: "#001b4d", color: "#fff", padding: "60px 0 25px" }}>
            <div style={{ maxWidth: "1400px", margin: "0 auto", padding: "0 40px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "50px" }}>
                    <div>
                        <h3 style={{ marginBottom: "20px", fontSize: "28px" }}>Contact Info</h3>
                        <p style={{ marginBottom: "12px", opacity: 0.9, fontSize: "18px" }}>📞 {data && data?.phone ? data?.phone : ""}</p>
                        <p style={{ marginBottom: "12px", opacity: 0.9, fontSize: "18px" }}>✉️ {data && data?.email ? data?.email : "admin@eflogistics.io"}</p>
                        <p style={{ opacity: 0.9, fontSize: "18px" }}>📍 {data && data?.address ? data?.address : ""}</p>
                    </div>

                    <div>
                        <h3 style={{ marginBottom: "20px", fontSize: "28px" }}>Follow Us</h3>
                        <div style={{ display: "flex", gap: "20px" }}>
                            <Link to={data && data?.facebookURL ? data?.facebookURL : "/"} target="_blank" style={socialIcon}><Facebook /></Link>
                            <Link to={data && data?.instagramURL ? data?.instagramURL : "/"} style={socialIcon}><Instagram /></Link>
                            <Link to={data && data?.twitterURL ? data?.twitterURL : "/"} style={socialIcon}><Twitter /></Link>
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "50px", borderTop: "1px solid rgba(255,255,255,0.15)", paddingTop: "25px", textAlign: "center", opacity: 0.8, fontSize: "16px" }}>{data && data?.copyRightText ? data?.copyRightText : ""}</div>
            </div>
        </footer>
    </div>);
};

const navLink = {
    color: "#fff",
    textDecoration: "none",
    fontSize: "16px",
    fontWeight: "500",
};

const socialIcon = {
    color: "#fff",
    textDecoration: "none",
    fontSize: "18px",
    fontWeight: "500",
};

export default CorporateLandingTemplate;